<template>
  <div
    class="bg-gray-300 hover:bg-opacity-25 font-opensans rounded-lg shadow-lg hover:shadow-xl cursor-pointer"
  >
    <div class="my-2 mx-4 font-semibold">
      Sportaccommodaties in dit sportcomplex:
    </div>
    <ul class="font-opensans m-4 text-sm truncate">
      <li v-for="acc in accommodaties" class="italic" v-bind:key="acc.id">
        {{ acc.naam }}
      </li>
    </ul>
    <button class="btn btn-blue" @click="$emit('showOnMap', sportcomplex.id)">
      Toon op kaart
    </button>
    <button
      class="btn btn-blue"
      @click="moveAccommodatie"
      v-if="hasPermission('update accommodatie')"
    >
      Verplaats accommodatie
    </button>
    {{ msg }}
  </div>
</template>

<script>
import { sortByAttr } from "../../common/utils.js";
export default {
  props: ["sportcomplex"],
  name: "AccommodatieClusterCard",
  data() {
    return {
      msg: null
    };
  },
  computed: {
    accommodaties() {
      return sortByAttr(this.sportcomplex.accommodaties, "naam");
    }
  },
  methods: {
    moveAccommodatie: async function() {
      const [ok, msg] = await this.$store.dispatch(
        "moveAccommodatieToSportcomplex",
        {
          accommodatie_id: this.$route.params.id,
          sportcomplex_id: this.sportcomplex.id
        }
      );

      if (ok) {
        this.msg = "Gegevens succesvol opgeslagen";
        this.$router.push({
          name: "Accommodatie",
          params: { id: this.$route.params.id }
        });
      } else {
        this.msg = msg;
      }
    }
  }
};
</script>
